const { fetcher } = require('services/helpers/responseHandler')

const reEnablePMSSync = subsidiaryId =>
  fetcher.put('internalonly/ReEnablePmsSync', subsidiaryId)

const tryLogin = ({ subsidiaryId, credentialString }) =>
  fetcher.post('internalonly/pms/try-login', {
    subsidiaryId,
    credentialString
  })

const occupancy = ({ fromDate, toDate, subsidiaryId }) =>
  fetcher.get('internalonly/subsidiary/occupancy', {
    fromDate,
    toDate,
    subsidiaryId
  })

const reEnableHostedMessaging = ({ HostMessagingAuthorizingPartyFullName }) =>
  fetcher.post('internalonly/subsidiary/hostnumber', {
    HostMessagingAuthorizingPartyFullName
  })

const internalOnlyApi = {
  reEnablePMSSync,
  tryLogin,
  occupancy,
  reEnableHostedMessaging
}

export default internalOnlyApi
